/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './approveJoinRequest.defs'
export { main as default } from './approveJoinRequest.defs'
